import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import MultiSelectPicker from '../MultiSelectPicker'
import { filterTriggerLabel } from './constants'

const CollectsFilter = ({ collects, value, onChange }) => {
  const options = useMemo(
    () => collects.map(collect => ({ value: collect.id, label: collect.name })), [collects]
  )

  const formatSelectedLabel = useCallback(
    count => filterTriggerLabel('Collecte', count, collects.length), [collects.length]
  )

  return (
    <MultiSelectPicker
      formatSelectedLabel={formatSelectedLabel}
      options={options}
      placeholder="Collecte"
      searchPlaceholder="Rechercher une collecte"
      selectedValues={value}
      onChange={onChange}
    />
  )
}

CollectsFilter.propTypes = {
  collects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.number).isRequired
}

CollectsFilter.defaultProps = {
  collects: []
}

export default CollectsFilter
